import { useContext, useMemo } from 'react';
import { UserContext } from '@/providers/UserContext';
import { useFormStore } from '@/store';
import { EmailTemplateContext } from './substituteEmailTemplate';

/**
 * @file useEmailTemplateContext.ts
 * @description Builds the context that email-template placeholder substitution
 * resolves against. Both FormEmailModal and WorkflowParameterSidebar call this —
 * `formNumber` is the only piece that varies between them (the modal accepts an
 * explicit prop override), the rest reads from useFormStore + UserContext.
 */

export const useEmailTemplateContext = (formNumber: string | undefined): EmailTemplateContext => {
    const { user, userProfile } = useContext(UserContext);
    const { form: pageForm, formVersion } = useFormStore();
    const senderName = user?.displayName ?? user?.email ?? undefined;
    const senderEmail = userProfile?.email;
    const senderPhone = userProfile?.phone?.formatted;
    return useMemo(() => ({
        formNumber,
        formVersionNumber: formVersion?.data?.formVersionNumber,
        formType: pageForm?.data?.formType,
        senderName,
        senderEmail,
        senderPhone,
        fields: formVersion?.data?.fields,
        entityReferences: formVersion?.data?.entityReferences,
    }), [
        formNumber,
        formVersion?.data?.formVersionNumber,
        pageForm?.data?.formType,
        senderName,
        senderEmail,
        senderPhone,
        formVersion?.data?.fields,
        formVersion?.data?.entityReferences,
    ]);
};
